/* loaded by smart-asset */
export default require("./assets/qrcode.i.svg")